import { useTranslation } from 'react-i18next'

export default function Image ({
  data,
  className,
}: {
  data: string | undefined;
  className: string;
}) {
  const { t: tc } = useTranslation('common')

  return (
    <img
      className={className}
      src={data}
      alt={tc('image_blog')}
      loading="lazy"
      decoding="async"
    />
  )
}
